import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=1e5352a4&"
import script from "./Img.vue?vue&type=script&lang=js&"
export * from "./Img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports